import { render, staticRenderFns } from "./PurchaseStats.vue?vue&type=template&id=4599054c&scoped=true&"
import script from "./PurchaseStats.vue?vue&type=script&lang=js&"
export * from "./PurchaseStats.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseStats.vue?vue&type=style&index=0&id=4599054c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599054c",
  null
  
)

export default component.exports